module.exports = __webpack_public_path__ + "static/media/eliberty4.b89d5c2b.jpg";